import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/theme-toggle.css';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  return (
    <label className="theme-switch" title={isDark ? 'Tema escuro' : 'Tema claro'}>
      <input className="theme-switch-input" type="checkbox" checked={isDark} onChange={toggleTheme}
        aria-label={isDark ? 'Ativar tema claro' : 'Ativar tema escuro'} />
      <span className="theme-switch-slider" aria-hidden="true">
        <svg className="theme-switch-icon theme-switch-sun" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5"/></svg>
        <svg className="theme-switch-icon theme-switch-moon" viewBox="0 0 24 24"><path d="M20.5 14.5A9 9 0 0 1 9.5 3.5a9 9 0 1 0 11 11Z"/></svg>
      </span>
    </label>
  );
}
